export default __webpack_public_path__ + "static/media/icono-catastrofica.e22e9f90.svg";